import { ENV_PRODUCTION } from '@mymahi/environment';

export const environment = {
    ...ENV_PRODUCTION
};
